import { CandidateProfileTalentListTableColumns } from 'modules/candidate-profile/tables/types/CandidateProfileTalentListTable';
import { TableV3Filters } from 'common/table/components/TableV3';
import { SearchableCandidateProfileListFilterInput } from 'generated-graphql/types';
import { getTalentListSearchClause } from 'modules/candidate-profile/tables/filters/getTalentListSearchClause';
import { getTeamsFilterClause } from 'modules/candidate-profile/tables/filters/getTeamsFilterClause';

type GetCandidateProfileTalentListFiltersProps = {
  filters?: TableV3Filters<CandidateProfileTalentListTableColumns>;
};

// The server adds the organization and visibility clauses.
export const getCandidateProfileTalentListFilters = ({
  filters
}: GetCandidateProfileTalentListFiltersProps):
  | SearchableCandidateProfileListFilterInput
  | undefined => {
  const clauses = [
    getTalentListSearchClause(filters?.searchFields),
    getTeamsFilterClause(filters?.filterValues?.teams)
  ].filter((clause) => clause !== undefined);

  if (clauses.length <= 1) {
    return clauses[0];
  }

  return { and: clauses };
};
